import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async getOpportunityList(adsId, date) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/suggestion/opportunity-list`,
      { adsId, date },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getLowPerformanceKeywords(adsId, date) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/suggestion/low-performance-keywords`,
      { adsId, date },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
